namespace GeniuzPOS.AdvPromo {
    export class VwAdvPromoBasicAndAdvActiveByPluColumns {
        static columnsKey = 'AdvPromo.VwAdvPromoBasicAndAdvActiveByPlu';
    }
}
